import { render, staticRenderFns } from "./lessons.vue?vue&type=template&id=4014005a&scoped=true&"
import script from "./lessons.vue?vue&type=script&lang=js&"
export * from "./lessons.vue?vue&type=script&lang=js&"
import style0 from "./lessons.vue?vue&type=style&index=0&id=4014005a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014005a",
  null
  
)

export default component.exports